import { BrowserModule } from '@angular/platform-browser';
import { NgModule, DoBootstrap, ApplicationRef } from '@angular/core';

import { AppComponent } from './app/app.component';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

import {
	MatInputModule, MatFormFieldModule, MatIconModule, MatButtonModule, MatDatepickerModule, MatNativeDateModule, MAT_SNACK_BAR_DEFAULT_OPTIONS,
	MatSnackBarModule, MatDialogModule, MatTabsModule, MatProgressBarModule, MatToolbarModule, MatSlideToggleModule, MatListModule, MatTooltipModule, MatSelectModule, MatCheckboxModule
} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth/auth.interceptor';
import { AuthComponent } from './auth/auth.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { BarbersComponent } from './barbers/barbers.component';
import { ApiService } from './api/api.service';
import { AppService } from './app/app.service';
import { AuthService } from './auth/auth.service';
import { BarbersService } from './barbers/barbers.service';
import { AppointmentsService } from './appointments/appointments.service';
import { ServicesService } from './services/services.service';
import { InventoryService } from './inventory/inventory.service';
import { ClientsService } from './clients/clients.service';
import { PhonePipe } from './phone/phone.pipe';
import { AppointmentFilterComponent } from './appointments/filter-dialog.component';
import { AppointmentComponent } from './appointments/appointment.component';
import { PhoneMaskDirective } from './phone/phone-mask.directive';
import { SettingsService } from './settings/settings.service';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { ShiftsComponent } from './shifts/shifts.component';
import { TimePickerComponent } from './shared/time-picker/time-picker.component';
import { AppointmentConfirmDialogComponent } from './appointments/appointment-confirm-dialog.component';
import { CallerIdService } from './phone/caller-id.service';
import { ClientComponent } from './clients/client.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { OfflineService } from './api/offline.service';
import { forkJoin, concat } from 'rxjs';
import { AuthRow } from './auth/auth.defs';

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    AppointmentsComponent,
    BarbersComponent,
	PhonePipe,
	AppointmentFilterComponent,
	AppointmentComponent,
	PhoneMaskDirective,
	ConfirmDialogComponent,
	ShiftsComponent,
	TimePickerComponent,
	AppointmentConfirmDialogComponent,
	ClientComponent,
  ],
  imports: [
    BrowserModule,
	// BrowserAnimationsModule,
	NoopAnimationsModule,
	FormsModule, ReactiveFormsModule,
	MatNativeDateModule,
	HttpClientModule,

    MatInputModule, MatFormFieldModule, MatIconModule, MatButtonModule, MatDatepickerModule,
	MatSnackBarModule, MatDialogModule, MatTabsModule, MatProgressBarModule, MatToolbarModule,
	MatSlideToggleModule, MatListModule, MatTooltipModule, MatSelectModule, MatCheckboxModule, ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
	//   {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
	  {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 0, verticalPosition: 'top', horizontalPosition: 'center', panelClass: 'warn'}},
	  ApiService,
	  AppService,
	  AuthService,
	  BarbersService,
	  AppointmentsService,
	  ServicesService,
	  InventoryService,
	  ClientsService,
	  SettingsService,
	  CallerIdService,
  ],
  entryComponents: [
	  AuthComponent, AppointmentFilterComponent, AppointmentComponent, ConfirmDialogComponent, ShiftsComponent, TimePickerComponent, AppointmentConfirmDialogComponent, ClientComponent,
	  AppComponent,
  ],
  bootstrap: []
})
export class AppModule implements DoBootstrap {

	constructor(
		private _offline: OfflineService,
		private _api: ApiService,
		private _auth: AuthService,
	) {	}

	ngDoBootstrap(app: ApplicationRef) {
		
		this._offline
			.ready
			.subscribe((resp) => {
				this._api
					.request<AuthRow>({'$/auth/current': {}}, 'auth.current')
					.subscribe(
						resp => {
							this._auth.set(resp);
							app.bootstrap(AppComponent);
						},
						err => {
							app.bootstrap(AppComponent);
						}
					)
			})
	}
 }
